import React from 'react';
import renderHTML from 'react-render-html';
import Modal from '../../../../components/modal';
import Button from '../../../../components/button/button';
import SummaryDetails from '../summary-details/summary-details';
import SelectionOption from '../selection-option/selection-option';
import { Desktop, Mobile } from '../../../../app-responsive';
import { customStylesDesktop, customStylesMobile } from '../../../../components/business-case-delete-modal/modal-styles-config';
import { stripStartingAndEndingPTags } from '../../ssm-homepage.actions';
import PopupHeader from '../popup-header/popup-header';
import './confirm-site-modal.css';

const ConfirmSiteModal = (props) => {
  const {
    modalIsOpen,
    onCloseDialogBox,
    authorableContent,
    siteAddress,
    showAddtionalBsipSection,
    confirmSiteCheckBoxChecked,
    onConfirmSiteCheckBoxChanged,
    handleSubmit,
    referenceNumber,
    formSubmitted,
    formSubmissionInProcess,
    handleProceedNextSite,
  } = props;
  const desktopModalStyles = { content: { ...customStylesDesktop.content, width: '75%' } };

  const {
    confirmSummaryText,
    bsipSummaryTitle,
    bsipSummaryText,
    privacyTitle,
    privacySummary,
    confirmCheckBoxId,
    confirmCheckboxLabel,
    confirmCheckboxDesc,
    submitButtonText,
    proceeedNextSiteText,
    summaryTitlePre,
    summaryTitlePost,
    siteSubmittedSummary,

  } = authorableContent;

  const referenceText = `${summaryTitlePre} ${referenceNumber} ${summaryTitlePost}`;

  const modalContent = customStyles => (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onCloseDialogBox}
      style={customStyles}
      ariaHideApp={false}
    >
      {formSubmitted === false &&
      <div className="confirm-site-modal">
        <PopupHeader PopTitle={siteAddress} PopupText={confirmSummaryText} />
        {showAddtionalBsipSection &&
        <SummaryDetails summaryTitle={bsipSummaryTitle} summaryText={bsipSummaryText} />
        }
        <SummaryDetails summaryTitle={privacyTitle} summaryText={privacySummary} />
        <SelectionOption
          iconType="checkBox"
          confirmAllCheckBoxId={confirmCheckBoxId}
          confirmAllCheckBoxLabel={confirmCheckboxLabel}
          confirmAllCheckBoxDesc={renderHTML(confirmCheckboxDesc)}
          confirmAllCheckBoxChecked={confirmSiteCheckBoxChecked}
          onCheckBoxStatusChanged={onConfirmSiteCheckBoxChanged}
        />
        <div className="row">
          <div className="col-12 text-right button-section">
            <Button
              className={`button do-business ${formSubmissionInProcess ? 'loading' : ''}`}
              buttonText={submitButtonText}
              disabled={!confirmSiteCheckBoxChecked}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
      }
      {formSubmitted &&
        <div className="confirm-site-modal proceeed-next-site">
          <PopupHeader PopTitle={siteAddress} PopupText={referenceText} textCenter />
          <div className="row">
            <div className="col-12">
              <div className="site-submitted-summary text-center">{renderHTML(stripStartingAndEndingPTags(siteSubmittedSummary))}</div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-right button-section">
              <Button
                className="button do-business"
                buttonText={proceeedNextSiteText}
                onClick={handleProceedNextSite}
              />
            </div>
          </div>
        </div>
      }
    </Modal>
  );

  return (
    <React.Fragment>
      <Mobile>
        {modalContent(customStylesMobile)}
      </Mobile>
      <Desktop>
        {modalContent(desktopModalStyles)}
      </Desktop>
    </React.Fragment>
  );
};

export default ConfirmSiteModal;
